module.exports = __webpack_public_path__ + "img/film-2.f648eee0.png";